import { auth } from '../firebase';
import { authService } from '../services/authService';
import { useUser, UserData } from '../contexts/UserContext';

export const useAuth = () => {
  const { user: userData, loading } = useUser();

  const signOut = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return {
    user: userData as UserData | null,
    loading,
    signOut,
    authService,
    isAuthenticated: !!userData,
  };
};
